/** Stage 2 deliberately has no responsibility-choice screen until its prototype is approved. */
export default function StaffSettlementPendingNotice({required,rtl}:{required:boolean;rtl:boolean}){
 if(!required)return null;
 return <div className="note bad" role="alert">{rtl
  ?"يتطلب هذا الدفع اختيار من يتحمل الاستقطاعات أو قطع الزي المتبقية مع ذكر السبب. شاشة الاختيار لم تُضف بعد. يمكنك الرجوع واختيار «حفظ، والدفع لاحقًا». لم يُسجل أي دفع."
  :"This final pay needs a choice and reason for each uncovered deduction or uniform piece. The responsibility screen is not available yet. Go back and choose Save, pay later. No payment has been recorded."}</div>;
}
